import { FormStates } from '@fundamental-ngx/cdk/forms';

export class KeyValueItemModel {
    name: string;
    state: FormStates = null;
    message: string = null;

    constructor(init?: Partial<KeyValueItemModel>) {
        Object.assign(this, init);
    }
}
